export const OPEN     = 'open';
export const NAVIGATE = 'navigate';
export const READY    = 'ready';
export const DESTROY  = 'destroy';
export const LOAD     = 'load';
export const SWITCH   = 'switch';


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/video-player/events.js
 **/